const giftCardsAr = {
  "gc.title": "بطاقات الهدايا",
  "gc.description": "بطاقات اشتراها العملاء، وبطاقات أصدرتها، ومبالغ مستردة على شكل بطاقات هدايا.",
  "gc.issue": "إصدار بطاقة هدية",
  "gc.issued": "صدرت بطاقة الهدية",
  "gc.view": "عرض البطاقة",
  "gc.code_once": "انسخ الرمز الآن: لن تراه كاملاً مرة أخرى. يستخدمه العميل عند الدفع.",
  "gc.emailed": "أُرسل الرمز بالبريد.",
  "gc.empty": "بِع بطاقات الهدايا وامنحها",
  "gc.empty_body": "أضف منتجاً بنوع بطاقة هدية لبيعها، أو أصدر بطاقة بنفسك لعميل أو مسابقة أو استرداد.",
  "gc.none": "لا توجد بطاقات مطابقة.",
  "gc.all": "الكل",
  "gc.search": "ابحث بآخر 4 أحرف أو العميل أو البريد أو الطلب",
  "gc.selling_hint": "لبيع بطاقات الهدايا أنشئ منتجاً وحدده كبطاقة هدية. كل وحدة تُشترى تصبح بطاقة تُرسل بالبريد إلى المشتري أو إلى من يختاره.",
  "gc.status.active": "نشطة",
  "gc.status.used": "مستنفدة",
  "gc.status.expired": "منتهية",
  "gc.status.disabled": "معطّلة",
  "gc.source.purchase": "مشتراة",
  "gc.source.manual": "أصدرها الفريق",
  "gc.source.refund": "استرداد",
  "gc.col.code": "الرمز",
  "gc.col.status": "الحالة",
  "gc.col.customer": "العميل",
  "gc.col.date": "التاريخ",
  "gc.col.balance": "الرصيد",
  "gc.col.source": "المصدر",
  "gc.value": "القيمة",
  "gc.code": "الرمز",
  "gc.code_hint": "من 8 إلى 20 حرفاً ورقماً. اتركه فارغاً لرمز عشوائي آمن.",
  "gc.customer": "العميل",
  "gc.recipient_email": "المستلم",
  "gc.recipient_hint": "أرسل البطاقة إلى هذا البريد بدلاً من بريد العميل.",
  "gc.message": "الرسالة",
  "gc.expires_on": "تاريخ الانتهاء",
  "gc.expires_hint": "إن تُرك فارغاً يُطبق الافتراضي من الميزات.",
  "gc.no_expiry": "لا تنتهي أبداً",
  "gc.note": "ملاحظة",
  "gc.note_hint": "لا يراها إلا الفريق.",
  "gc.notify": "إرسال الرمز بالبريد إلى المستلم أو العميل",
  "gc.balance": "الرصيد",
  "gc.of_initial": "من {amount}",
  "gc.history": "السجل",
  "gc.after": "الرصيد {amount}",
  "gc.txn.issue": "صدرت",
  "gc.txn.debit": "استُخدمت عند الدفع",
  "gc.txn.credit": "أُعيد المبلغ",
  "gc.txn.adjust": "تعديل",
  "gc.details": "التفاصيل",
  "gc.created": "تاريخ الإنشاء",
  "gc.sent_on": "أُرسلت في {when}",
  "gc.sending_on": "تُرسل في {when}",
  "gc.expiry_set": "لا يمكن استخدام البطاقة بعد هذا التاريخ.",
  "gc.never_expires": "هذه البطاقة لا تنتهي أبداً.",
  "gc.adjust": "تعديل الرصيد",
  "gc.add_balance": "إضافة",
  "gc.remove_balance": "خصم",
  "gc.amount": "المبلغ",
  "gc.reason": "السبب",
  "gc.reason_hint": "يُحفظ في سجل البطاقة وسجل النشاط.",
  "gc.disable": "تعطيل",
  "gc.disable_title": "تعطيل بطاقة الهدية؟",
  "gc.disable_body": "لن يمكن استخدامها عند الدفع حتى تفعّلها مجدداً. يبقى رصيدها محفوظاً.",
  "gc.enable": "تفعيل",
  "gc.disabled_toast": "عُطّلت بطاقة الهدية",
  "gc.enabled_toast": "فُعّلت بطاقة الهدية",
  "gc.refund_to_cards_note": "بطاقات الهدايا التي دفعت هذا الطلب تسترد مبلغها أولاً.",
  "gc.refund_as_card": "استرداد الباقي كبطاقة هدية",
  "gc.refund_as_card_hint": "رصيد في المتجر: تُرسل بطاقة هدية جديدة إلى العميل بدلاً من إعادة المبلغ إلى وسيلة الدفع.",
} as const;

export default giftCardsAr;
